import React, {useEffect, useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useConvertBase64} from "../../../hooks/useConvertBase64";
import {useGetQuery} from "../../../hooks/useQueryHooks";
import {ResponseList} from "../../../models/clientModels/interfaces/Response";
import {
  EDCategory,
  initialEDCategoryListParams,
} from "../../../models/serverModels/education/EDCategory";
import {EDCurriculum} from "../../../models/serverModels/education/EDCurriculum";

import * as categoryListApi from "../../../api/educationApi/educationCategoryApi";

import * as tutorApi from "../../../api/educationApi/tutorApi";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import MWCaption from "../../../components/MWCaption";
import MWInputFile from "../../../components/MWInputFile";
import {useDepartmentList} from "../../../hooks/useDepartmentList";
import {month, year} from "../../../models/clientModels/data/date";
import {EDTutor, initialTutorListParams} from "../../../models/serverModels/education/EDTutor";
import {
  FormContents,
  FormSection,
  InputFileContainer,
} from "../../../styledComponents/StyledCreateForm";
type CategoryType = {
  value: number;
  label: string;
};

type SubTitleColorProps = {
  captionColor?: string;
};

const CurriculumForm = ({captionColor}: SubTitleColorProps) => {
  const tokenState = useRecoilValue(tokenSelector);

  const {convertChangeHandler, image} = useConvertBase64();
  const {departmentList} = useDepartmentList();

  const isMobile = useMediaQuery("(max-width: 780px)");

  const methods = useFormContext<EDCurriculum>();

  const {
    setValue,
    getValues,
    control,
    watch,
    formState: {errors},
  } = methods;

  // region: Query (교육과정 카테고리 리스트)
  const {
    data: category,
    isLoading,
    isSuccess,
  } = useGetQuery<ResponseList<EDCategory>>({
    key: ["EducationCategoryListAll", {...initialEDCategoryListParams, token: tokenState}],
    api: () => categoryListApi.getListAll({...initialEDCategoryListParams, token: tokenState}),
  });

  //note react-query - 강사리스트

  const {data: tutorList} = useGetQuery<ResponseList<EDTutor>>({
    key: ["TutorList", initialTutorListParams],
    api: () => tutorApi.getList({...initialTutorListParams, token: tokenState}),
  });

  //note 부서 선택리스트

  //note 카테고리 State
  const [middleCategory, setMiddleCategory] = useState<CategoryType[]>([]);

  const [subCategory, setSubCategory] = useState<CategoryType[]>([]);

  // region: function (교육과정 필터링)
  const mainCategoryHandler = (event: SelectChangeEvent<number>) => {
    setMiddleCategory([]);
    setValue("category1UID", event.target.value as number);
    category?.items.filter(
      (item) =>
        item.uid === event.target.value &&
        item.subCategories.map((item) =>
          setMiddleCategory((prev) => [{value: item.uid, label: item.name}, ...prev])
        )
    );
  };

  const middleCategoryHandler = (event: SelectChangeEvent<number>) => {
    setSubCategory([]);
    setValue("category2UID", event.target.value as number);
    category?.items.map((item) =>
      item.subCategories.filter(
        (item) =>
          item.uid === event.target.value &&
          item.subCategories.map((item) =>
            setSubCategory((prev) => [{value: item.uid, label: item.name}, ...prev])
          )
      )
    );
  };

  const setCategoryHandler = (mainId: number, middleId: number) => {
    const middleCategory = category?.items.find((item) => item.uid === mainId);
    setSubCategory([]);
    middleCategory?.subCategories.map((item) =>
      setMiddleCategory((prev) => [{value: item.uid, label: item.name}, ...prev])
    );

    const subCategory = middleCategory?.subCategories.find((item) => item.uid === middleId);
    setSubCategory([]);

    subCategory?.subCategories.map((item) =>
      setSubCategory((prev) => [{value: item.uid, label: item.name}, ...prev])
    );
  };

  const fullChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      departmentList?.items.map((item, index) => setValue(`departmentsUIDs.${index}`, item?.uid!));
    } else {
      setValue(`departmentsUIDs`, []);
    }
  };

  useEffect(() => {
    isSuccess && setCategoryHandler(getValues("category1UID"), getValues("category2UID"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <React.Fragment>
      <FormSection>
        <MWCaption title={"교육과정"} color={captionColor} icon={<SchoolIcon />} />
        <FormContents container rowSpacing={4}>
          <Grid container item xs={12} sm={12} lg={4}>
            <Controller
              name="category1UID"
              control={control}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={2}
                    lg={2}
                    xl={2}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="mainCategory">대분류 : </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Select
                      {...field}
                      id="mainCategory"
                      size="small"
                      placeholder="대분류"
                      defaultValue={field.value}
                      onChange={mainCategoryHandler}
                      style={{width: "100%"}}
                    >
                      <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>
                      {category?.items.map((item) => (
                        <MenuItem key={item.uid} value={item.uid}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid container item xs={12} sm={12} lg={4}>
            <Controller
              name="category2UID"
              control={control}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={2}
                    lg={2}
                    xl={2}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="middleCategory">중분류 : </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Select
                      {...field}
                      id="middleCategory"
                      size="small"
                      placeholder="중분류"
                      defaultValue={field.value}
                      onChange={middleCategoryHandler}
                      style={{width: "100%"}}
                    >
                      <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>
                      {middleCategory.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid container item xs={12} sm={12} lg={4}>
            <Controller
              name="category3UID"
              defaultValue={0}
              control={control}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={2}
                    lg={2}
                    xl={2}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="subCategory">세분류 : </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Select
                      {...field}
                      id="subCategory"
                      size="small"
                      placeholder="세분류"
                      style={{width: "100%"}}
                      defaultValue={field.value}
                    >
                      <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>
                      {subCategory.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid container item xs={12} sm={12} lg={4}>
            {tutorList?.items !== undefined && (
              <Controller
                name="tutorUID"
                control={control}
                render={({field}) => (
                  <Grid container alignItems="center" justifyContent="flex-start">
                    <Grid
                      item
                      xs={0}
                      sm={0}
                      md={2}
                      lg={2}
                      xl={2}
                      sx={{display: {xs: "none", sm: "none", md: "block"}}}
                    >
                      <label htmlFor="tutor">강사 : </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                      <Select
                        {...field}
                        id="tutor"
                        size="small"
                        placeholder="강사"
                        defaultValue={field.value}
                        style={{width: "100%"}}
                      >
                        <MenuItem disabled value={field.value}>
                          강사를 선택하세요
                        </MenuItem>
                        {tutorList?.items.map((item) => (
                          <MenuItem key={item.uid} value={item.uid}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                )}
              />
            )}
          </Grid>
          <Grid container item xs={12} sm={12} lg={4}>
            <Controller
              name="year"
              control={control}
              defaultValue={2022}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={2}
                    lg={2}
                    xl={2}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="originDate">평가년도 : </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Select
                      {...field}
                      id="years"
                      size="small"
                      placeholder="연"
                      style={{width: "100%"}}
                    >
                      <MenuItem style={{display: "none"}}></MenuItem>
                      {year?.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}년
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid container item xs={12} sm={12} lg={4}>
            <Controller
              name="month"
              control={control}
              defaultValue={1}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={2}
                    lg={2}
                    xl={2}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="originDate">평가월 : </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Select
                      {...field}
                      id="years"
                      size="small"
                      placeholder="월"
                      style={{width: "100%"}}
                    >
                      <MenuItem style={{display: "none"}}></MenuItem>
                      {month?.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}월
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid container item xs={12} sm={12} lg={12} sx={{marginTop: "16px"}}>
            <Controller
              name="minusPoint"
              control={control}
              defaultValue={0}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start" columns={16}>
                  <Grid
                    item
                    xs={0}
                    sm={2}
                    md={1}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="minusPoint">평가설정 : </label>
                  </Grid>
                  <Grid item xs={16} sm={14} md={15}>
                    <Box
                      sx={{
                        display: {xs: "block", sm: "block", md: "flex"},
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{flexShrink: 0, color: "dimgray"}}>
                        응시 횟수 1회마다 총점에서
                      </Typography>
                      <Box
                        sx={{
                          width: {
                            xs: "100%",
                            sm: "100%",
                            md: "14%",
                          },
                          margin: {
                            xs: "4px 0",
                            sm: "4px 0",
                            md: "0 12px",
                          },
                        }}
                      >
                        <TextField
                          {...field}
                          id="minusPoint"
                          type="number"
                          size="small"
                          placeholder="평가설정"
                          inputProps={{min: 0, max: 100}}
                        />
                      </Box>
                      <Typography sx={{flexShrink: 0, color: "dimgray"}}>점씩 차감된다.</Typography>
                    </Box>
                  </Grid>
                  <Typography>{errors.minusPoint?.message}</Typography>
                </Grid>
              )}
            />
          </Grid>
        </FormContents>
      </FormSection>
      <FormSection>
        <MWCaption
          title={"첨부파일 - 1MB 미만의 파일만 가능합니다"}
          color={captionColor}
          icon={<CreateNewFolderIcon />}
        />
        <InputFileContainer container rowSpacing={2}>
          {isMobile ? (
            <MWInputFile file="base64" fileName="textBookFile" buttonLabel="교안등록" />
          ) : (
            <Grid container item xs={12} sm={12} lg={12}>
              <Controller
                name="base64"
                control={control}
                render={({field: {onChange, name}}) => (
                  <Grid container alignItems="center" justifyContent="flex-start">
                    <Grid
                      item
                      xs={0}
                      sm={0}
                      md={1}
                      lg={1}
                      xl={1}
                      sx={{display: {xs: "none", sm: "none", md: "block"}}}
                    >
                      <label style={{cursor: "pointer"}} htmlFor="base64">
                        교안등록 :
                      </label>
                    </Grid>
                    <Grid item xs={4} sm={3} md={2} lg={2} xl={2}>
                      <Button variant="contained" component="label">
                        파일 업로드
                        <TextField
                          sx={{display: "none"}}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            convertChangeHandler(event, setValue, name, "textBookFile")
                          }
                          type="file"
                          id="base64"
                          size="small"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={7} sm={8} md={8} lg={8} xl={8}>
                      <p>{getValues("textBookFile")}</p>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                      <IconButton
                        aria-label="delete"
                        color="secondary"
                        onClick={() => {
                          setValue("base64", "");
                          setValue("textBookFile", "");
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                    {errors.textBookFile && <Typography>{errors.textBookFile.message}</Typography>}
                  </Grid>
                )}
              />
            </Grid>
          )}
        </InputFileContainer>
      </FormSection>
      <FormSection>
        <MWCaption title={"대상부서 선택"} color={captionColor} icon={<CheckBoxIcon />}>
          <FormControlLabel
            labelPlacement="start"
            label="전체선택"
            control={
              <Checkbox
                sx={{padding: "0 8px", color: "white", " :checked": {color: "white"}}}
                checked={
                  departmentList?.items.length === watch().departmentsUIDs.length ? true : false
                }
                onChange={fullChangeHandler}
              />
            }
            sx={{".MuiFormControlLabel-label": {fontSize: 14, color: "#a4a3d4"}}}
          />
        </MWCaption>
        <FormContents container rowSpacing={2}>
          <Grid container item xs={12} sm={12} lg={12}>
            <Controller
              name="departmentsUIDs"
              control={control}
              render={({field}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <FormGroup style={{display: "flex", flexWrap: "wrap", flexDirection: "row"}}>
                    {departmentList !== undefined &&
                      departmentList?.items.map((item, index) => {
                        return (
                          <FormControlLabel
                            {...field}
                            key={item.uid}
                            label={item.name}
                            control={
                              <Checkbox
                                id="departmentsUIDs"
                                checked={
                                  watch().departmentsUIDs.includes(item?.uid!) ? true : false
                                }
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                  event.target.checked
                                    ? setValue("departmentsUIDs", [...field.value, item?.uid!])
                                    : setValue(
                                        "departmentsUIDs",
                                        field.value.filter((list) => list !== item.uid)
                                      );
                                }}
                              />
                            }
                          />
                        );
                      })}
                  </FormGroup>
                </Grid>
              )}
            />
          </Grid>
        </FormContents>
      </FormSection>
    </React.Fragment>
  );
};

export default CurriculumForm;
